export default __webpack_public_path__ + "static/media/legend_windspeed.feb9e17b.png";